import { Category } from '@components/CategoryRow/CategoryRow';

// Home page category strip (order matters): shown on store home + Feeds CategoryRow when enabled
export const popularCategories: Category[] = [
  {
    id: 'ecommerce',
    name: 'ecommerce',
    displayName: 'ECommerce',
    icon: `${process.env.PUBLIC_URL}/images/categories/ecommerce.png`,
    searchQuery: 'ecommerce'
  },
  {
    id: 'food',
    name: 'food',
    displayName: 'Food',
    icon: `${process.env.PUBLIC_URL}/images/categories/food.png`,
    searchQuery: 'food'
  },
  {
    id: 'electronics',
    name: 'electronics',
    displayName: 'Electronics',
    icon: `${process.env.PUBLIC_URL}/images/categories/electronics.png`,
    searchQuery: 'electronics'
  },
  {
    id: 'travel',
    name: 'travel',
    displayName: 'Travel',
    icon: `${process.env.PUBLIC_URL}/images/categories/travel.png`,
    searchQuery: 'travel'
  },
  {
    id: 'fashion',
    name: 'fashion',
    displayName: 'Fashion',
    icon: `${process.env.PUBLIC_URL}/images/categories/fashion.png`,
    searchQuery: 'fashion'
  },
  {
    id: 'view-all',
    name: 'View All',
    displayName: 'View All',
    icon: `${process.env.PUBLIC_URL}/images/categories/view-all.svg`,
    searchQuery: ''
  }
];

// Define important categories for home page (shown after popular categories)
export const importantCategories: Category[] = [
  {
    id: 'groceries',
    name: 'groceries',
    displayName: 'Groceries',
    icon: `${process.env.PUBLIC_URL}/images/categories/groceries.png`,
    searchQuery: 'groceries'
  },
  {
    id: 'home_decor',
    name: 'home_decor',
    displayName: 'Home & Decor',
    icon: `${process.env.PUBLIC_URL}/images/categories/home-decor.png`,
    searchQuery: 'home decor'
  },
  {
    id: 'jewellery',
    name: 'jewellery',
    displayName: 'Jewellery',
    icon: `${process.env.PUBLIC_URL}/images/categories/jewellery.png`,
    searchQuery: 'jewellery'
  },
  {
    id: 'kids',
    name: 'kids',
    displayName: 'Kids',
    icon: `${process.env.PUBLIC_URL}/images/categories/kids.png`,
    searchQuery: 'kids'
  },
  {
    id: 'pharmacies',
    name: 'pharmacies',
    displayName: 'Pharmacies',
    icon: `${process.env.PUBLIC_URL}/images/categories/pharmacies.png`,
    searchQuery: 'pharmacies'
  },
  {
    id: 'gifting',
    name: 'gifting',
    displayName: 'Gifting',
    icon: `${process.env.PUBLIC_URL}/images/categories/gifting.png`,
    searchQuery: 'gifting'
  },
  {
    id: 'special_offers',
    name: 'special_offers',
    displayName: 'Special Offers',
    icon: `${process.env.PUBLIC_URL}/images/categories/special-offers.png`,
    searchQuery: 'special offers',
    tag: { text: 'Hot Deals', type: 'hot' }
  },
  {
    id: 'events',
    name: 'events',
    displayName: 'Events',
    icon: `${process.env.PUBLIC_URL}/images/categories/events.png`,
    searchQuery: 'events'
  }
];

// Define all categories for category page
// Category names must match backend values exactly
export const allCategories: Category[] = [
  {
    id: 'car_rentals',
    name: 'car_rentals',
    displayName: 'Car Rentals',
    icon: `${process.env.PUBLIC_URL}/images/categories/car-rentals.png`,
    searchQuery: 'car rentals'
  },
  {
    id: 'ecommerce',
    name: 'ecommerce',
    displayName: 'ECommerce',
    icon: `${process.env.PUBLIC_URL}/images/categories/ecommerce.png`,
    searchQuery: 'ecommerce'
  },
  {
    id: 'electronics',
    name: 'electronics',
    displayName: 'Electronics',
    icon: `${process.env.PUBLIC_URL}/images/categories/electronics.png`,
    searchQuery: 'electronics'
  },
  {
    id: 'entertainment',
    name: 'entertainment',
    displayName: 'Entertainment',
    icon: `${process.env.PUBLIC_URL}/images/categories/entertainment.png`,
    searchQuery: 'entertainment'
  },
  {
    id: 'events',
    name: 'events',
    displayName: 'Events',
    icon: `${process.env.PUBLIC_URL}/images/categories/events.png`,
    searchQuery: 'events'
  },
  {
    id: 'fashion',
    name: 'fashion',
    displayName: 'Fashion',
    icon: `${process.env.PUBLIC_URL}/images/categories/fashion.png`,
    searchQuery: 'fashion'
  },
  {
    id: 'food',
    name: 'food',
    displayName: 'Food',
    icon: `${process.env.PUBLIC_URL}/images/categories/food.png`,
    searchQuery: 'food'
  },
  {
    id: 'gifting',
    name: 'gifting',
    displayName: 'Gifting',
    icon: `${process.env.PUBLIC_URL}/images/categories/gifting.png`,
    searchQuery: 'gifting'
  },
  {
    id: 'groceries',
    name: 'groceries',
    displayName: 'Groceries',
    icon: `${process.env.PUBLIC_URL}/images/categories/groceries.png`,
    searchQuery: 'groceries'
  },
  {
    id: 'home_decor',
    name: 'home_decor',
    displayName: 'Home & Decor',
    icon: `${process.env.PUBLIC_URL}/images/categories/home-decor.png`,
    searchQuery: 'home decor'
  },
  {
    id: 'jewellery',
    name: 'jewellery',
    displayName: 'Jewellery',
    icon: `${process.env.PUBLIC_URL}/images/categories/jewellery.png`,
    searchQuery: 'jewellery'
  },
  {
    id: 'kids',
    name: 'kids',
    displayName: 'Kids',
    icon: `${process.env.PUBLIC_URL}/images/categories/kids.png`,
    searchQuery: 'kids'
  },
  {
    id: 'pharmacies',
    name: 'pharmacies',
    displayName: 'Pharmacies',
    icon: `${process.env.PUBLIC_URL}/images/categories/pharmacies.png`,
    searchQuery: 'pharmacies'
  },
  {
    id: 'shopping',
    name: 'shopping',
    displayName: 'Shopping',
    icon: `${process.env.PUBLIC_URL}/images/categories/shopping.png`,
    searchQuery: 'shopping'
  },
  {
    id: 'special_offers',
    name: 'special_offers',
    displayName: 'Special Offers',
    icon: `${process.env.PUBLIC_URL}/images/categories/special-offers.png`,
    searchQuery: 'special offers',
    tag: { text: 'Hot', type: 'hot' }
  },
  {
    id: 'travel',
    name: 'travel',
    displayName: 'Travel',
    icon: `${process.env.PUBLIC_URL}/images/categories/travel.png`,
    searchQuery: 'travel'
  },
  {
    id: 'wellness',
    name: 'wellness',
    displayName: 'Wellness',
    icon: `${process.env.PUBLIC_URL}/images/categories/wellness.png`,
    searchQuery: 'wellness'
  }
];

/** Store home category row: same catalog as /categories, curated order (fills rows via CSS grid). */
const HOME_STORE_CATEGORY_IDS: string[] = [
  'ecommerce',
  'food',
  'electronics',
  'travel',
  'fashion',
  'groceries',
  'wellness',
  'entertainment',
  'home_decor',
  'jewellery'
];

export const homeStoreCategoryStrip: Category[] = HOME_STORE_CATEGORY_IDS.map((id) =>
  allCategories.find((c) => c.id === id)
).filter((c): c is Category => c != null);

